/* ===== ETERNALLÉ THEME — MAIN.JS v2 ===== */

document.addEventListener('DOMContentLoaded', function () {

  /* ══════════════════════════════════════════
     HEADER SCROLL SHADOW
  ══════════════════════════════════════════ */
  const header = document.getElementById('SiteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ══════════════════════════════════════════
     MOBILE MENU
  ══════════════════════════════════════════ */
  const mobileToggle  = document.getElementById('MobileMenuToggle');
  const mobileMenu    = document.getElementById('MobileMenu');
  const mobileClose   = document.getElementById('MobileMenuClose');
  const mobileOverlay = document.getElementById('MobileMenuOverlay');

  function openMobileMenu() {
    mobileMenu && mobileMenu.classList.add('open');
    mobileOverlay && mobileOverlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu && mobileMenu.classList.remove('open');
    mobileOverlay && mobileOverlay.classList.remove('show');
    document.body.style.overflow = '';
  }
  mobileToggle  && mobileToggle.addEventListener('click', openMobileMenu);
  mobileClose   && mobileClose.addEventListener('click', closeMobileMenu);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileMenu);

  /* ══════════════════════════════════════════
     PRODUCT IMAGE GALLERY (unlimited + fast)
  ══════════════════════════════════════════ */
  const mainImg      = document.getElementById('MainProductImage');
  const loadOverlay  = document.getElementById('ImageLoadingOverlay');
  const thumbBtns    = document.querySelectorAll('#ProductThumbnails .thumbnail');

  // Preload images on hover for instant switch
  thumbBtns.forEach(btn => {
    btn.addEventListener('mouseenter', function () {
      const src = this.dataset.src;
      if (src) {
        const preloader = new Image();
        preloader.src = src;
      }
    });

    btn.addEventListener('click', function () {
      const src = this.dataset.src;
      if (!mainImg || !src || mainImg.src.includes(src.split('?')[0])) return;

      // Show loading overlay briefly
      if (loadOverlay) loadOverlay.classList.add('loading');

      const newImg = new Image();
      newImg.onload = function () {
        mainImg.src = src;
        if (loadOverlay) loadOverlay.classList.remove('loading');
      };
      newImg.onerror = function () {
        mainImg.src = src; // fallback: set anyway
        if (loadOverlay) loadOverlay.classList.remove('loading');
      };
      newImg.src = src;

      thumbBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ══════════════════════════════════════════
     VARIANT SELECTOR
  ══════════════════════════════════════════ */
  const variantInput  = document.getElementById('ProductVariantId');
  const variantBtns   = document.querySelectorAll('.variant-btn');
  const variantLabel = document.getElementById('SelectedVariantLabel');

  variantBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      variantBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      if (variantInput) variantInput.value = this.dataset.variantId;
      if (variantLabel) variantLabel.textContent = this.textContent.trim();
    });
  });

  /* ══════════════════════════════════════════
     PRODUCT ACCORDION
  ══════════════════════════════════════════ */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const content  = this.nextElementSibling;

      document.querySelectorAll('.accordion-trigger').forEach(t => {
        t.setAttribute('aria-expanded', 'false');
        const c = t.nextElementSibling;
        if (c) c.hidden = true;
      });

      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        if (content) content.hidden = false;
      }
    });
  });

  /* ══════════════════════════════════════════
     FAQ ACCORDION
  ══════════════════════════════════════════ */
  document.querySelectorAll('.faq-trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const answer   = this.nextElementSibling;

      document.querySelectorAll('.faq-trigger').forEach(t => {
        t.setAttribute('aria-expanded', 'false');
        const a = t.nextElementSibling;
        if (a) a.hidden = true;
      });

      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        if (answer) answer.hidden = false;
      }
    });
  });

  /* ══════════════════════════════════════════
     CART DRAWER — la lógica vive en assets/cart-drawer.js
     (sección "Carrito", editable en el personalizador)
  ══════════════════════════════════════════ */
  function openCartDrawer() {
    if (window.EtCart) return window.EtCart.open();
    window.location.href = '/cart';
  }

  function fetchCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function updateCartBadges(count) {
    const headerCount = document.getElementById('CartCount');
    const drawerCount = document.getElementById('CartDrawerCount');
    if (headerCount) headerCount.textContent = count;
    if (drawerCount) drawerCount.textContent = count;
  }

  /* ══════════════════════════════════════════
     ADD TO CART — AJAX + OPEN DRAWER
  ══════════════════════════════════════════ */
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = this.querySelector('.add-to-cart');
      const originalHTML = btn ? btn.innerHTML : '';

      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span class="drawer-spinner" style="width:18px;height:18px;border-width:2px;display:inline-block;vertical-align:middle;margin-right:6px;"></span>Añadiendo…';
      }

      try {
        const formData = new FormData(this);
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!resp.ok) {
          const err = await resp.json();
          throw new Error(err.description || 'Error adding to cart');
        }

        // Success — open drawer
        openCartDrawer();

        if (btn) {
          btn.innerHTML = '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg> ¡Añadido!';
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 2000);
        }

      } catch (err) {
        console.error(err);
        alert(err.message || 'No se pudo añadir al carrito. Inténtalo de nuevo.');
        if (btn) {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }
      }
    });
  }

  /* ══════════════════════════════════════════
     SCROLL REVEAL
  ══════════════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll(
      '.stat-item, .ingredient-card, .hiw-step, .review-card, .benefit-item, .no-harsh-img-wrap'
    );
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    revealEls.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = `opacity 0.5s ease ${i * 0.06}s, transform 0.5s ease ${i * 0.06}s`;
      observer.observe(el);
    });
  }

  /* ══════════════════════════════════════════
     STICKY ADD TO CART BAR
  ══════════════════════════════════════════ */
  const addToCartBtn = document.querySelector('.add-to-cart');
  const stickyBar    = createStickyBar();

  if (addToCartBtn && stickyBar) {
    const obs = new IntersectionObserver(entries => {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(addToCartBtn);
  }

  function createStickyBar() {
    if (!document.querySelector('.product-hero-top')) return null;
    const bar = document.createElement('div');
    bar.className = 'sticky-atc-bar';
    bar.innerHTML = `
      <div class="container">
        <div class="sticky-atc-inner">
          <div class="sticky-product-name">
            <span class="stars" style="font-size:0.85rem;">★★★★★</span>
            <strong id="StickyProductTitle"></strong>
          </div>
          <button class="btn btn-primary sticky-atc-btn" id="StickyAtcBtn">Add to Cart</button>
        </div>
      </div>`;
    document.body.appendChild(bar);

    const titleEl    = document.querySelector('.product-title');
    const stickyTitle = bar.querySelector('#StickyProductTitle');
    if (titleEl && stickyTitle) stickyTitle.textContent = titleEl.textContent.trim();

    const stickyBtn = bar.querySelector('#StickyAtcBtn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const mainBtn = document.querySelector('.add-to-cart');
        if (mainBtn) mainBtn.click();
      });
    }
    return bar;
  }

  /* ══════════════════════════════════════════
     REVIEWS PAGINATION (UI)
  ══════════════════════════════════════════ */
  document.querySelectorAll('.reviews-page-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.reviews-page-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ══════════════════════════════════════════
     SMOOTH ANCHOR SCROLL
  ══════════════════════════════════════════ */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ══════════════════════════════════════════
     INIT — load cart count on page load
  ══════════════════════════════════════════ */
  if (window.EtCart) window.EtCart.refreshCount();
  else fetchCart().then(cart => updateCartBadges(cart.item_count)).catch(() => {});

});
